import { Icon, IconButton, LinearProgress, Pagination, 
        Paper, Table, TableBody, TableCell, TableContainer,
        TableFooter, TableHead, TableRow,
        styled, tableCellClasses
    } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { Enviroment } from "../../shered/enviroments";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IListagemFranquia, FranquiaService } from "../../shered/services/api/franquia/FranquiaService"
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";

export const ListagemDeMinhaFranquia: React.FC = () => {

    const [searchParams, SetSearchParams] = useSearchParams();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { isAuthenticated, logout } = useAuthContext();
    const [rows, setRows] = useState<IListagemFranquia[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoadig] = useState(true);
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });


    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);


    useEffect(() => {
        setIsLoadig(true);
        debounce(() => {
            FranquiaService.getByIdUsuario()
                .then((result) => {
                    setIsLoadig(false);
                    const lst = result.data.dado;
                    setRows(lst);
                    setTotalCount(result.data.totalRegistros);
                })
                .catch((errors) => {
                    setIsLoadig(false);
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;

                });
        })
    }, []);

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            FranquiaService.deleteById(id)
                .then((result) => {
                    setIsLoadig(false);
                    setRows(oldRows => [
                        ...oldRows.filter(oldRow => oldRow.codigo !== id),
                    ]);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                }).catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                })
        }
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 13,
            padding: "4px"
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,

        },
        '&:last-child th': {
            border: 0,
            padding: "16px 10px "
        },
    }));

    const handleRedirect = (codigo: number) =>{

        if (codigo > 0) {            
            let crypt = UtilidadeService.crypt(codigo.toString()); 
            navigate(`/usuario/franquia/detalhe/${crypt}`);
        }
    }

    return (
        <LayoutBaseDePagina
            titulo="Listagem de franquias"
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarInputBusca
                mostrarBotaoNovo={false}
                textoDaBusca={busca}
                //aoClicarBotaoNovo={() => navigate('/usuario/franquias/detalhe/nova')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}

            />}>
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell width={100}>Ações</StyledTableCell>
                            <StyledTableCell>Código</StyledTableCell>
                            <StyledTableCell>Franquia</StyledTableCell>
                            <StyledTableCell>Código Liga</StyledTableCell>
                            <StyledTableCell>Liga</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => (
                            <StyledTableRow key={row.codigo}>
                                <StyledTableCell>
                                    <IconButton size="small" onClick={() => handleDelete(row.codigo)}>
                                        <Icon>delete</Icon>
                                    </IconButton>
                                    <IconButton size="small" onClick={() => { handleRedirect(row.codigo); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo_Liga.toString()))}}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                </StyledTableCell>
                                <StyledTableCell>{row.codigo}</StyledTableCell>
                                <StyledTableCell>{row.nome}</StyledTableCell>
                                <StyledTableCell>{row.codigo_Liga}</StyledTableCell>
                                <StyledTableCell>{row.nome_Liga}</StyledTableCell>
                            </StyledTableRow>
                        ))
                        }
                    </TableBody>
                    {totalCount === 0 && !isLoading && (
                        <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                    )}
                    <TableFooter>
                        {isLoading && (
                            <StyledTableRow>
                                <StyledTableCell colSpan={7}>
                                    <LinearProgress variant="indeterminate" />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                        {(totalCount > 0 && totalCount > Enviroment.LIMITE_DE_LINHAS) && (
                            <StyledTableRow>
                                <StyledTableCell colSpan={7}>
                                    <Pagination
                                        page={pagina}
                                        count={Math.ceil(totalCount / Enviroment.LIMITE_DE_LINHAS)}
                                        onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                    />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableFooter>
                </Table>
            </TableContainer>
        </LayoutBaseDePagina>
    );
};